import { faker } from '@faker-js/faker'

import { ReviewAuthorCountry, UserReview } from '../../contracts/review'
import { asBuilder } from '../asBuilder'

export const getUserReview = asBuilder((): UserReview => {
  return {
    id: faker.number.int(),
    author: {
      id: faker.number.int(),
      country: faker.helpers.enumValue(ReviewAuthorCountry),
      nickName: faker.string.uuid(),
      level: faker.number.int(),
      profileImage: faker.string.uuid(),
    },
    totalRating: faker.number.int(),
    description: faker.string.uuid(),
    beforePhotos: faker.helpers.multiple(() => ({ url: faker.image.url() })),
    afterPhotos: faker.helpers.multiple(() => ({ url: faker.image.url() })),
    procedureProofApproved: faker.datatype.boolean(),
    postedAtUtc: '2021-06-08T02:51:56Z',
    editedLastAtUtc: '2021-06-09T02:51:56Z',
    translation: {
      language: faker.helpers.arrayElement(['ko', 'ja', 'en']),
      description: faker.string.uuid(),
    },
  }
})
